import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'schedules-calendar',
};

const useStyles = makeStyles((theme: Theme) => {
  const cardStyle = {
    borderRadius: 8,
    border: `1px solid ${theme.palette.grey[100]}`,
    background: theme.palette.common.white,
  };

  return {
    root: {
      margin: theme.spacing(0, -0.25),
      '& .fc-header-toolbar': {
        ...cardStyle,
        justifyContent: 'center',
        position: 'relative',
        margin: `${theme.spacing(0, 0.25)} !important`,
        padding: theme.spacing(2.5),
        borderBottom: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        '&:after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: 0,
          left: 20,
          right: 20,
          height: 1,
          background: theme.palette.grey[100],
        },
      },
      '& .fc-toolbar-chunk': {
        margin: theme.spacing(0, 1.5),
      },
      '& .fc-toolbar-title': {
        fontSize: 18,
        textTransform: 'capitalize',
      },
      '& .fc-button': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        padding: 0,
        outline: 'none',
      },
      '& .fc-button-primary': {
        border: 0,
        background: theme.palette.primary.main,
        '&:hover': {
          background: theme.palette.primary.light,
        },
        '&:focus, &:active': {
          boxShadow: 'none!important',
          background: `${theme.palette.primary.dark} !important`,
        },
      },
      '& .fc-scroller-harness': {
        border: 0,
      },
      '& .fc-scrollgrid': {
        border: 0,
      },
      '& .fc-scrollgrid-section': {
        '&>th, &>td': {
          border: 0,
        },
      },
      '& .fc-scrollgrid-section-header': {
        '& .fc-scroller-harness': {
          ...cardStyle,
          margin: theme.spacing(0, 0.25),
          padding: theme.spacing(2, 0),
          borderTop: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
      },
      '& .fc-col-header-cell-cushion': {
        textTransform: 'capitalize',
        fontSize: 16,
        color: theme.palette.grey[400],
      },
      '& .fc-scrollgrid-sync-table': {
        borderSpacing: '2px',
        borderCollapse: 'separate',
      },
      '& .fc-col-header-cell': {
        border: 0,
      },
      '& .fc-daygrid-day': {
        border: 0,
      },
      '& .fc-daygrid-day-frame': {
        ...cardStyle,
        padding: theme.spacing(2),
        '&:before, &:after': {
          display: 'none',
        },
      },
      '& .fc-daygrid-day-top': {
        position: 'absolute',
        bottom: theme.spacing(1.75),
        right: theme.spacing(2),
        padding: 0,
      },
      '& .fc-daygrid-day-bottom': {
        padding: '0 !important',
        '&:not(:first-child)': {
          marginTop: `${theme.spacing(1)} !important`,
        },
        '&:before, &:after': {
          display: 'none',
        },
      },
      '& .fc-daygrid-day-events': {
        '&:before, &:after': {
          display: 'none',
        },
      },
      '& .fc-scrollgrid-sync-inner .fc-daygrid-day-events': {
        minHeight: '160px !important',
      },
      '& .fc-daygrid-event-harness': {
        '&:before, &:after': {
          display: 'none',
        },
        '&:not(:first-child)': {
          marginTop: '4px !important',
        },
      },
      '& .fc-daygrid-event': {
        display: 'block',
        margin: '0 !important',
        padding: '0 !important',
        cursor: 'pointer',
        '&:before, &:after': {
          display: 'none',
        },
        '&:hover': {
          background: 'rgba(82, 190, 128, 0.2)',
        },
        '&:focus, &:focus': {
          boxShadow: 'none',
          background: 'rgba(82, 190, 128, 0.5)',
        },
      },
      '& .fc-daygrid-day-number': {
        padding: 0,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.grey[900],
      },
      '& .fc-daygrid-more-link': {
        display: 'inline-flex',
        padding: theme.spacing(0.5),
        color: theme.palette.common.white,
        fontSize: 12,
        borderRadius: 4,
        background: theme.palette.info.main,
      },
      '& .fc-popover': {
        borderRadius: 4,
      },
      '& .fc-popover-header': {
        padding: theme.spacing(1),
        color: theme.palette.common.white,
        borderRadius: '4px 4px 0 0',
        background: theme.palette.info.main,
      },
    },
    disabled: {
      pointerEvents: 'none',
      '& .fc-daygrid-day-frame' : {
        opacity: 0.9,
        background: '#f5f5f5',
      }
    },
    hasEventsCell: {},
    emptyEventsCell: {},
    addEventsCell: {
      '&:not($hasEventsCell), &:not($disabled)': {
        '&:hover': {
          '& .fc-daygrid-day-frame': {
            position: 'relative',
            cursor: 'pointer',
            borderColor: theme.palette.info.main,
            '&:before': {
              content: '"+"',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              fontSize: 48,
              color: theme.palette.info.main,
            },
          },
        },
      },
    },
    card: {
      padding: theme.spacing(1),
      color: theme.palette.grey[800],
      borderRadius: 8,
    },
    cardHeader: {},
  };
}, options);

export default useStyles;
